(() => {
  "use strict";
  var t = {
      985: (t, e, i) => {
        var n = i(58),
          o = (i(129), i(357), i(755));
        class s {
          constructor() {
            this.container = document.querySelector(".main-product"), this.$mainImagesSlide = this.container.querySelectorAll(".main-slide-image"), this.zoomInitialized = !1, this.mobileMediaQuery = window.matchMedia("(max-width: 710px)"), this.init()
          }
          init() {
            this.createZooms(), this.onResize()
          }
          onResize() {
            this.mobileMediaQuery.addEventListener("change", (t => {
              t.matches && !0 === this.zoomInitialized ? this.destroyZooms() : !1 === this.zoomInitialized && this.createZooms()
            }))
          }
          createZooms() {
            this.mobileMediaQuery.matches || (this.$mainImagesSlide.forEach((t => {
              const e = t.querySelector("img").getAttribute("src");
              o(t).zoom({
                url: e
              })
            })), this.zoomInitialized = !0)
          }
          destroyZooms() {
            this.$mainImagesSlide.forEach((t => {
              o(t).trigger("zoom.destroy")
            })), this.zoomInitialized = !1
          }
        }
        var r = i(755);
        class a extends window.HTMLElement {
          constructor() {
            super(), this.$mainProduct = document.querySelector(".main-product"), this.$mainCarousel = this.querySelector(".product-main-carousel"), this.$thumbnailsCarousel = this.querySelector(".product-thumbnails-carousel"), this.slidesCount = Number(this.$thumbnailsCarousel.dataset.slidesCount), this.variantsStyle = r(this.$mainProduct).find(".main-product-form").attr("data-variants-style"), this.mainCarousel = null, this.init()
          }
          init() {
            this.initCarousels(), this.loadYoutubeVideos(), this.goToCurrentVariantSlide(), this.updateOnVariantChange(), new s
          }
          initCarousels() {
            this.initMainCarousel(), this.initThumbnailsCarousel(), this.showCarousels()
          }
          initMainCarousel() {
            const t = {
              slidesToShow: 1,
              swipeToSlide: !0,
              arrows: 1,
              speed: 300,
              rows: 0,
              asNavFor: this.$thumbnailsCarousel,
              dots: !0,
              touchThreshold: 500,
              dotsClass: "slick-dots product-main-carousel-dots",
              responsive: [{
                breakpoint: 711,
                settings: {
                  adaptiveHeight: !0
                }
              }]
            };
            this.mainCarousel = r(this.$mainCarousel).slick(t), this.mainCarousel.on("beforeChange", ((t, e, i) => {
              const n = e.$slides[i].querySelector("video");
              null !== n && n.pause(), window.setTimeout((() => {
                r(".product-carousel iframe").each((function() {
                  this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*")
                }))
              }), 0)
            })), this.mainCarousel.on("afterChange", ((t, e, i) => {
              const n = e.$slides[i],
                o = n.querySelector("iframe"),
                s = n.querySelector("video");
              null !== s && (s.muted = !0, s.play());
              try {
                null !== o && o.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*")
              } catch (t) {
                window.console.log(t)
              }
            }))
          }
          /*
          initThumbnailsCarousel() {
            const t = {
              slidesToShow: 7,
              swipeToSlide: !0,
              dots: !1,
              arrows: !1,
              focusOnSelect: true,
              centerMode: true,
              asNavFor: this.$mainCarousel,
              draggable: true,
              infinite: false,
              speed: 300
            };
            r(this.$thumbnailsCarousel).slick(t)
          }
          */  



          // Debe quedar así
          initThumbnailsCarousel() {
              const t = {
                  slidesToShow: 7,
                  swipeToSlide: !0,
                  dots: !1,
                  arrows: !1,
                  focusOnSelect: true,
                  centerMode: false, // <--- LÍNEA MODIFICADA
                  asNavFor: this.$mainCarousel,
                  draggable: true,
                  infinite: false,
                  speed: 50
              };
              r(this.$thumbnailsCarousel).slick(t)
          }










          goToCurrentVariantSlide() {
            const t = this.$mainProduct.querySelector("#selectedVariant");
            if (null === t) return;
            const e = JSON.parse(t.textContent);
            if (void 0 === e.featured_media) return;
            const i = this.querySelector(`.main-slide[data-media-id="${e.featured_media.id}"]`);
            if (null === i) return;
            const n = parseInt(i.getAttribute("data-slick-index"), 10);
            this.mainCarousel.slick("slickGoTo", n, !0)
          }
          goToSelectedVariantSlide(t) {
            if (void 0 === t.featured_media) return;
            const e = t.featured_media.id,
              i = this.querySelector(`.main-slide[data-media-id="${e}"]`);
            if (null === i) return;
            const n = parseInt(i.getAttribute("data-slick-index"), 10);
            this.mainCarousel.slick("slickGoTo", n)
          }
          updateOnVariantChange() {
            const t = this.$mainProduct.querySelector(`variant-${this.variantsStyle}`);
            null !== t && window.addEventListener("variant::changed", (() => {
              let e = t.currentVariant;
              void 0 === e && (e = {
                available: !1
              }), this.goToSelectedVariantSlide(e)
            }))
          }
          loadYoutubeVideos() {
            void 0 !== window.YT && window.YT.ready((() => {
              r(this.mainCarousel).find(".iframe-video-replace-tag").each(((t, e) => {
                const i = r(e).attr("data-id"),
                  n = r(e).parent(),
                  o = new window.YT.Player(e, {
                    videoId: i,
                    playerVars: {
                      loop: 1,
                      origin: window.location.origin
                    }
                  });
                n.children().data("youtubePlayer", o)
              }))
            }))
          }
          showCarousels() {
            r(this).addClass("show")
          }
        }
        var l = i(755);
        class u extends window.HTMLElement {
          constructor() {
            super(), this.typingTimer = null, this.doneTypingInterval = 1e3, this.$quantitySelectorButtons = l(".quantity-selector-button"), this.$input = l("#quantity"), this.init()
          }
          init() {
            this.initInput(), this.initButtons()
          }
          initInput() {
            this.$input.on("change", (t => {
              const e = Number(l(t.target).val()),
                i = l("#quantity-minus");
              e <= 1 ? i.addClass("disabled") : i.removeClass("disabled")
            })), this.$input.on("keyup", (t => {
              window.clearTimeout(this.typingTimer), this.typingTimer = window.setTimeout((() => {
                this.doneTyping(l(t.target))
              }), this.doneTypingInterval)
            })), this.$input.on("keydown", (() => {
              window.clearTimeout(this.typingTimer)
            }))
          }
          initButtons() {
            this.$quantitySelectorButtons.on("click", (t => {
              const e = l(t.target),
                {
                  action: i
                } = e.data();
              let n = Number(this.$input.val());
              if ("plus" === i) {
                const t = n += 1;
                this.$input.val(t).trigger("change")
              }
              if ("minus" === i && n > 1) {
                const t = n -= 1;
                this.$input.val(t).trigger("change")
              }
            }))
          }
          doneTyping(t) {
            const e = Number(t.val());
            ("" === e || e <= 0) && t.val(1).trigger("change")
          }
        }
        class c {
          constructor(t) {
            this.$section = t, window.customElements.define("product-carousel", a), window.customElements.define("quantity-selector", u), null != window.KueskipayAdvertising && (this.kueskyObject = new window.KueskipayAdvertising, this.kueskyObject.init(), this.kueskyInjectStyles()), this.listeners(), this.setCountdown(), this.descriptionExpand(), this.starsReviewsClick()
          }
          listeners() {
            window.addEventListener("variant::changed", this.onVariantChange.bind(this))
          }
          onVariantChange(t) {
            this.updateColorOption(t.detail)
          }
          kueskyInjectStyles() {
            const t = this.$section.querySelector("kueskipay-widget");
            if (null == t) return;
            const e = document.createElement("style");
            e.textContent = window.kueskyPayCustomStylesRoutes, t.shadowRoot.appendChild(e)
          }
          updateColorOption(t) {
            const e = this.$section.querySelector(".product-form-color-option");
            if (null == e) return;
            const i = t.currentVariant[e.dataset.position];
            e.querySelector(".form-label-option-value").innerHTML = i
          }
          setCountdown() {
            const t = this.$section.querySelector(".main-product-countdown-timer-wrapper");
            if (null == t) return;
            const e = t.dataset.endTime;
            if (null == e) return;
            const i = t.querySelector(".main-product-countdown-days-left"),
              n = t.querySelector(".main-product-countdown-hours-left"),
              o = t.querySelector(".main-product-countdown-minutes-left"),
              s = new Date(e).getTime(),
              r = window.setInterval(a, 1e3);

            function a() {
              const e = (new Date).getTime(),
                a = s - e;
              if (a <= 0) return window.clearInterval(r), void t.classList.remove("show");
              t.classList.add("show");
              const l = Math.floor(a / 864e5),
                u = Math.floor(a % 864e5 / 36e5),
                c = Math.floor(a % 36e5 / 6e4);
              i.innerHTML = l, n.innerHTML = u, o.innerHTML = c
            }
            a()
          }
          descriptionExpand() {
            const t = this.$section.querySelector(".main-product-accordion-content-description");
            if (!t) return;
            const e = t.querySelector(".main-product-accordion-description");
            const i = t.querySelector(".main-product-accordion-description-button");
            const n = "short";
            // Si no hay texto o botón, no hacemos nada (contenido queda completo)
            if (!e || !i) return;
            e.clientHeight > 140 && (t.classList.add(n), t.classList.add("show-button")), i.addEventListener("click", (() => {
              t.classList.toggle(n), t.classList.contains(n) ? i.innerText = "Leer Más" : i.innerText = "Leer Menos"
            }))
          }

          starsReviewsClick() {
            const t = document.querySelector(".header-main-wrapper"),
              e = this.$section.querySelector(".main-product-reviews .loox-rating"),
              i = document.querySelector(".shopify-section.product-reviews-row");
            null != e && null != i && e.addEventListener("click", (e => {
              e.preventDefault();
              let n = i.getBoundingClientRect().top;
              n -= t.clientHeight, window.scroll({
                top: n,
                behavior: "smooth"
              })
            }))
          }
        }
        const d = {
          onLoad() {
            this.product = new c(this.container)
          }
        };
        (0, n.z2)("main-product", d)
      }
    },
    e = {};

  function i(n) {
    if (e[n]) return e[n].exports;
    var o = e[n] = {
      exports: {}
    };
    return t[n].call(o.exports, o, o.exports, i), o.exports
  }
  i.m = t, i.x = t => {}, i.d = (t, e) => {
    for (var n in e) i.o(e, n) && !i.o(t, n) && Object.defineProperty(t, n, {
      enumerable: !0,
      get: e[n]
    })
  }, i.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e), i.j = 658, (() => {
    var t = {
        658: 0
      },
      e = [
        [985, 729, 83, 351]
      ],
      n = t => {},
      o = (o, s) => {
        for (var r, a, [l, u, c, d] = s, h = 0, m = []; h < l.length; h++) a = l[h], i.o(t, a) && t[a] && m.push(t[a][0]), t[a] = 0;
        for (r in u) i.o(u, r) && (i.m[r] = u[r]);
        for (c && c(i), o && o(s); m.length;) m.shift()();
        return d && e.push.apply(e, d), n()
      },
      s = globalThis.webpackChunkgetmore_workflow = globalThis.webpackChunkgetmore_workflow || [];

    function r() {
      for (var n, o = 0; o < e.length; o++) {
        for (var s = e[o], r = !0, a = 1; a < s.length; a++) {
          var l = s[a];
          0 !== t[l] && (r = !1)
        }
        r && (e.splice(o--, 1), n = i(i.s = s[0]))
      }
      return 0 === e.length && (i.x(), i.x = t => {}), n
    }
    s.forEach(o.bind(null, 0)), s.push = o.bind(null, s.push.bind(s));
    var a = i.x;
    i.x = () => (i.x = a || (t => {}), (n = r)())
  })(), i.x()
})();